import { render, staticRenderFns } from "./SetupWrapperView.vue?vue&type=template&id=251957ec&"
import script from "./SetupWrapperView.vue?vue&type=script&lang=js&"
export * from "./SetupWrapperView.vue?vue&type=script&lang=js&"
import style0 from "./SetupWrapperView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports